'use client';

import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { type FC, type ReactNode, useState } from 'react';

export type ExpanderProps = { items: ReactNode[]; visibleItems: number };

import styles from './o-index.module.scss';

export const Expander: FC<ExpanderProps> = ({ items, visibleItems }) => {
  const [isExpanderOpen, setIsExpanderOpen] = useState(false);

  return (
    <>
      <ul>{items.slice(0, isExpanderOpen ? items.length : visibleItems).map((item) => item)}</ul>

      <TextCTA as="button" className={styles['expander-button']} onClick={() => setIsExpanderOpen(!isExpanderOpen)}>
        {isExpanderOpen ? 'Weniger anzeigen' : 'Mehr anzeigen'}
      </TextCTA>
    </>
  );
};
